import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setCurrency } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);

  const loadMeta = useCallback(async () => {
    const { data } = await api.get("/meta");
    setCurrency(data.settings);
    setMeta(data);
  }, []);

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      await loadMeta();
      setUser(data);
    } catch {
      setUser(false);
    }
  }, [loadMeta]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await loadMeta();
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Déconnexion serveur impossible :", e?.message);
    }
    setUser(false);
  };

  const can = (module, action = "voir") =>
    !!user && (user.is_admin || (user.permissions?.[module] || []).includes(action));

  return (
    <AuthCtx.Provider value={{ user, meta, login, logout, can, loadMeta }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
